var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spaceCenter common common-form-inline" },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.pageData,
            "label-col": { span: 7 },
            "wrapper-col": { span: 13 },
            rules: _vm.rules
          }
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "账户名称", prop: "cstNm" } },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.params.recvAccNm) + "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "账 户 号 ", prop: "accNo" } },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.params.recvAccNo) + "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "开户银行", prop: "account" } },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.params.recvBankNm) + "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "提现金额", prop: "amount" } },
            [
              _c("user-currency", {
                staticClass: "text-size-20 text-color-orange",
                attrs: { value: _vm.params.amount }
              }),
              _vm._v(" 元\n        ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "提现密码", prop: "txnPwd" } },
            [
              _c("a-input", {
                attrs: { type: "password" },
                model: {
                  value: _vm.pageData.txnPwd,
                  callback: function($$v) {
                    _vm.$set(_vm.pageData, "txnPwd", $$v)
                  },
                  expression: "pageData.txnPwd"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-748dc3e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748dc3e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/withdraw/confirmInfo.vue
// module id = gK3J
// module chunks = 1